export class ESHOP_ROUTES {
	static ROOT: string = '/eshop';
	static ROOT_1: string = 'eshop';

	static ORDERS = 'orders';
	static PRODUCTS = 'products';
}